<template>
    <div>
        123
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    beforeRouteLeave(to,from,next){
        console.log(to)
        console.log(to.name)
        if(to.name=="tab切换的测试"){
            next(true)
        }else{
            next({path:'/TabText'})
        }
        // next()
    },
    methods:{

    },
    
}
</script>

<style scoped>

</style>